import Component from "./LoadingSmall";

export default Component;
